import{a as e}from"./chunk-YSXGDEY5.mjs";function o(a){return a.replace(/([a-z])([A-Z])/g,"$1_$2").toLowerCase()}e(o,"snakeCase");export{o as a};
